export function insert(moneyBox: MoneyBox, amount: MoneyAmount): MoneyBox {
  return {
    today: amount,
    total: moneyBox.total + amount,
  };
}
